import React from 'react'
import NavBar from '../Components/Main/NavBar'
import TopProducts from '../Components/Main/TopProducts'
import TopCategories from '../Components/Main/TopCategories'
import CompanySlider from '../Components/Main/CompanySlider'
import Features from '../Components/Main/Features'
import Footer from '../Components/Main/Footer'
import Hero from '../Components/Main/Hero'
const main = () => {
  return (
    <div className='main-container'>
        <NavBar/>
        <Hero/>
        <TopProducts/>
        <TopCategories/>
        <CompanySlider/>
        <Features/>
        <Footer/>
    </div>
  )
}

export default main